// 与扩展（lingzhi-clipper/src/shared/constants.ts）一致的几个上限。
export const LIMITS = {
  /** 一条回答带回来的引用最多留几条。 */
  references: 12,
  /** 引用弹层里的原文片段最多多少字。 */
  snippetChars: 280,
  /** 一条回答最多多少字：到了这里说明模型在胡写，自动停下。 */
  answerChars: 60_000,
} as const
